
function EditEventModal({
  isOpen,
  onClose,
  selectedEvent,
  setSelectedEvent,
  setIsViewingEventModalOpen,
  employees,
  setToast,
  handleSaveEventEdit,
}) {
  if (!isOpen || !selectedEvent) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans">
        <h3 className="text-xl font-bold mb-4 text-purple-700">Edit Event</h3>

        <div className="space-y-3">
          {/* Event Type */}
          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={selectedEvent.event_type || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, event_type: e.target.value })
            }
          >
            <option value="" disabled>
              Event Type
            </option>
            <option value="travel">Travel / Driving / Van</option>
            <option value="office">Office / Corporate</option>
            <option value="rest">Rest / PTO / Personal Leave</option>
            <option value="training">
              Training / Orientation / Fusionsplice / (High/Low) Top Van
            </option>
            <option value="no_job">No Job</option>
          </select>

          {/* Event Title */}
          <input
            type="text"
            placeholder="Event Title"
            value={selectedEvent.title || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, title: e.target.value })
            }
            className="w-full border px-3 py-2 rounded"
          />

          {/* Date & Time */}
          <input
            type="datetime-local"
            value={selectedEvent.date_and_time || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, date_and_time: e.target.value })
            }
            className="w-full border px-3 py-2 rounded"
          />

          {/* Primary Technician */}
          <select
            className="w-full border px-3 py-2 rounded bg-white"
            value={selectedEvent.primary_technician || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, primary_technician: e.target.value })
            }
          >
            <option value="" disabled>
              Primary Technician
            </option>
            {employees
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((emp) => (
                <option key={emp.id} value={emp.name}>
                  {emp.name}
                </option>
              ))}
          </select>

          {/* Description */}
          <input
            placeholder="Description (optional)"
            value={selectedEvent.description || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, description: e.target.value })
            }
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        {/* Buttons */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={() => {
              onClose();
              if (selectedEvent && selectedEvent.event_type !== "work") {
                setIsViewingEventModalOpen(true);
              }
            }}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            onClick={() => handleSaveEventEdit(selectedEvent)}
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditEventModal;